import React, {useEffect, useState} from 'react';
import {
    Button,
    Card,
    CardBody,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader, Input, Spinner,
    Typography
} from "@material-tailwind/react";
import {
    BuildingOffice2Icon, EnvelopeIcon, GlobeAltIcon, PaperClipIcon, PlusCircleIcon, MinusCircleIcon, ArchiveBoxArrowDownIcon, ArchiveBoxXMarkIcon, PrinterIcon
} from "@heroicons/react/24/outline";
import {Menu} from "../components/common/Menu";
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis, Tooltip} from "recharts";
import getData from "../api/axiosInstance";
import axios from "axios";
import {
    ArrowLongDownIcon, ArrowLongUpIcon,
    ArrowUpTrayIcon, CheckCircleIcon,
    PhoneIcon, TrashIcon,
    UserGroupIcon,
    XMarkIcon
} from "@heroicons/react/16/solid";
import {Link, useNavigate} from "react-router-dom";
import jwt_decode from "jwt-decode";
import {format, parseISO, subMonths} from "date-fns";

function HomePage() {

    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [detaljiKorisnika, setDetaljiKorisnika] = useState([]);

    // send email
    const [issueType, setIssueType] = useState("");
    const [message, setMessage] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [attachment, setAttachment] = useState(null);

    const [newSifraKorisnika, setNewSifraKorisnika] = useState("");
    const [sortedDataGraph, setSortedDataGraph] = useState([]);

    const [defaultDetaljiKorisnika, setDefaultDetaljiKorisnika] = useState(null);
    const [selectedSifra, setSelectedSifra] = useState("");
    const [isSifraChanged, setIsSifraChanged] = useState(false);

    // dialogs
    const [openContactFormErrorDialog, setOpenContactFormErrorDialog] = useState(false);
    const [openEmailConfirmationDialog, setOpenEmailConfirmationDialog] = useState(false);
    const [openStatusNeispravanDialog, setOpenStatusNeispravanDialog] = useState(false);
    const [openPoveziDetaljeKorisnikaDialog, setOpenPoveziDetaljeKorisnikaDialog] = useState(false);
    const [openOdveziDetaljeKorisnikaDialog, setOpenOdveziDetaljeKorisnikaDialog] = useState(false);
    const [openPopulateConsumptionHistoryDialog, setOpenPopulateConsumptionHistoryDialog] = useState(false);
    const [openPopulateConsumptionHistoryWithZeroDialog, setOpenPopulateConsumptionHistoryWithZeroDialog] = useState(false);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);

    // is loading/uploading
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPopulateWithData, setIsLoadingPopulateWithData] = useState(false);
    const [isLoadingPopulateWithZero, setIsLoadingPopulateWithZero] = useState(false);
    const [isUploadingDatabase, setIsUploadingDatabase] = useState(false);

    // error/success message
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");


    // za admina

    const [attachmentCsv, setAttachmentCsv] = useState(null);
    const [openAttachmentCsvSentDialog, setOpenAttachmentCsvSentDialog] = useState(false);
    const [openAttachmentCsvChooseDialog, setOpenAttachmentCsvChooseDialog] = useState(false);

    const [openDeleteRegistrovaniKorisnikDialog, setOpenDeleteRegistrovaniKorisnikDialog] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [openVerifyRegistrovaniKorisnikDialog, setOpenVerifyRegistrovaniKorisnikDialog] = useState(false);

    // sort and search reg korisnici
    const [registrovaniKorisnici, setRegistrovaniKorisnici] = useState([]);
    const [sortConfig, setSortConfig] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    // sort and search svi korisnici/prostori
    const [sviKorisnici, setSviKorisnici] = useState([]);
    const [sortConfigSviKorisnici, setSortConfigSviKorisnici] = useState(null);
    const [searchQuerySviKorisnici, setSearchQuerySviKorisnici] = useState('');

    // token functions
    const token = localStorage.getItem("token");

    const headers = {
        'Authorization': `Bearer ${token}`
    };

    const checkToken = () => {
        try {
            // Dekodiramo token i proveravamo datum isteka
            const decodedToken = jwt_decode(token);
            const currentTime = Date.now() / 1000; // Sadašnji timestamp u sekundama

            if (decodedToken.exp < currentTime) {
                console.log("🚨 Token je istekao! Brišem token i preusmeravam na login...");
                localStorage.removeItem("token");
                navigate("/login");
                return false;
            }
            return true;
        } catch (error) {
            console.log("🚨 Token nije validan! Brišem token i preusmeravam na login...");
            localStorage.removeItem("token");
            navigate("/login");
            return false;
        }
    };

    useEffect(() => {
        getData(
            `/users/me`,
            headers,
            setUser,
            "Error fetching user data"
        )
    }, []);

    useEffect(() => {
        getData(
            "/users/all",
            headers,
            setRegistrovaniKorisnici,
            "Error fetching registrovani korisnici"
        )
    }, []);

    useEffect(() => {
        getData(
            "/svi_korisnici/all",
            headers,
            setSviKorisnici,
            "Error fetching svi korisnici"
        )
    }, []);

    useEffect(() => {
        getData(
            `/svi_korisnici/default_detalji_korisnika`,
            headers,
            setDefaultDetaljiKorisnika,
            "Error fetching default detalji korisnika"
        )
    }, []);

    useEffect(() => {
        // Drugi endpoint za listu svih korisnika
        getData(
            `/svi_korisnici/svi_detalji_korisnika`,
            headers,
            (data) => {
                setDetaljiKorisnika(data); // Postavi podatke u stanje
            },
            "Error fetching svi detalji korisnika"
        );
    }, []);

    useEffect(() => {
        getData(
            `/consumption_history/show`,
            headers,
            (data) => {
                // Filtriraj podatke za selektovanog korisnika
                const filteredData = data
                    .map((korisnik) => {
                        if (String(korisnik.sifraKorisnika) === String(selectedSifra)) { // Konvertuj obe vrednosti u string
                            return korisnik.istorijaPotrosnje;
                        }
                        return null;
                    })
                    .filter((item) => item !== null);

                // Sada filtriraj samo istoriju potrošnje i popuni prazne mesece
                const filledData = fillEmptyData(filteredData.flat()); // `.flat()` je za spajanje niza u jedan niz

                setSortedDataGraph(filledData); // Ažuriraj sortedDataGraph sa popunjenim podacima
            },
            "Error fetching data graph"
        );
    }, [selectedSifra]); // Trigger kada se menja selektovani korisnik

    // istorija potrosnje - sve funkcije
    const fillEmptyData = (data) => {
        const maxLength = 13;

        if (!Array.isArray(data) || data.length === 0) {
            return [];
        }

        const sortedData = [...data]; // NE sortiramo jer baza vraća tačan redosled
        let lastDatum = parseISO(sortedData[0].datum); // Uzimamo najstariji datum iz baze (prvi element)
        const existingMonths = new Set(sortedData.map((entry) => format(parseISO(entry.datum), "yyyy-MM"))); // Postojeći meseci

        const filledData = [...sortedData];

        while (filledData.length < maxLength) {
            lastDatum = subMonths(lastDatum, 1);
            const newDatum = format(lastDatum, "yyyy-MM-01");

            if (!existingMonths.has(format(lastDatum, "yyyy-MM"))) {
                filledData.push({ datum: newDatum, ocitano: 0 });
                existingMonths.add(format(lastDatum, "yyyy-MM"));
            }
        }

        return filledData.reverse(); // ✅ OBRĆEMO ceo niz da ide S DESNA NA LEVO
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('sr-RS', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date);
    };

    const convertMonthToSerbian = (monthInEnglish) => {
        const months = {
            January: 'Januar',
            February: 'Februar',
            March: 'Mart',
            April: 'April',
            May: 'Maj',
            June: 'Jun',
            July: 'Jul',
            August: 'Avgust',
            September: 'Septembar',
            October: 'Oktobar',
            November: 'Novembar',
            December: 'Decembar'
        };
        return months[monthInEnglish] || monthInEnglish;
    };

    const srMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'];

    const formatToSerbianLatin = (date) => {
        const monthIndex = date.getMonth(); // Dobijamo indeks meseca (0-11)
        const year = date.getFullYear(); // Dobijamo godinu
        return `${srMonths[monthIndex]} ${year}`; // Vraćamo formatiran mesec i godinu
    };

    const TooltipContent = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0];
            if (data.payload.ocitano !== undefined) {
                const dateString = data.payload.datum; // Koristimo datum sa bekenda
                const date = new Date(dateString);

                // Proverite da li je datum validan
                if (isNaN(date)) {
                    console.error("Invalid date:", dateString);
                    return null;
                }

                // Formatiranje datuma u "Februar 2024" (na engleskom)
                const options = { year: 'numeric', month: 'long' };
                const formattedDateEnglish = new Intl.DateTimeFormat('en-US', options).format(date);

                // Pretvori mesec sa engleskog na srpski
                const [monthInEnglish, year] = formattedDateEnglish.split(' ');
                const formattedDateSerbian = `${convertMonthToSerbian(monthInEnglish)} ${year}`;

                return (
                    <div className="p-1 pl-2 pr-2">
                        <p className="text-gray-900 border-b-2">{formattedDateSerbian}</p>
                        <p className="font-semibold text-right text-green-chart mt-1 mb-1">{`${(data.payload.ocitano).toFixed(2)} kWh`}</p>
                    </div>
                );
            }
        }

        return null;
    };

    // error dialog
    const handleOpenErrorDialog = () => {
        setOpenErrorDialog(!openErrorDialog);
    };

    // povezi i odvezi prostor - user function
    const handlePoveziKorisnikaSubmit = async (e) => {
        e.preventDefault();

        if (!newSifraKorisnika) {
            setErrorMessage("Šifra korisnika je obavezna!");
            setSuccessMessage("");
            return;
        }

        setIsLoading(true);
        setErrorMessage("");
        setSuccessMessage("");

        try {
            // Dohvati token iz localStorage
            const token = localStorage.getItem("token");
            console.log("token: " + token)

            // Kreiraj JSON objekat sa šifrom korisnika
            const requestBody = {
                sifraKorisnika: newSifraKorisnika
            };

            const API_URL = process.env.REACT_APP_API_URL;

            // Slanje POST zahteva sa šifrom korisnika
            const response = await axios.post(
                `${API_URL}/svi_korisnici/povezi_detalje_korisnika`,
                requestBody,  // Pošaljemo JSON objekat sa šifrom korisnika u telu
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            if (response.status === 200) {
                setSuccessMessage("Korisnik je uspešno povezan sa prostorom.");
                setNewSifraKorisnika(""); // Resetovanje vrednosti inputa
                window.location.reload();
            }
        } catch (error) {
            setErrorMessage("Došlo je do greške prilikom dodavanja novog prostora. Proverite šifru korisnika i pokušajte ponovo.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleOdveziKorisnikaSubmit = async (e) => {
        e.preventDefault();

        if (!selectedSifra) {
            setErrorMessage("Ne možete ukloniti jedini prostor.");
            setSuccessMessage("");
            return;
        }

        setIsLoading(true);
        setErrorMessage("");
        setSuccessMessage("");

        try {
            // Dohvati token iz localStorage
            const token = localStorage.getItem("token");

            // Kreiraj JSON objekat sa šifrom korisnika
            const requestBody = {
                sifraKorisnika: selectedSifra
            };

            const API_URL = process.env.REACT_APP_API_URL;

            // Slanje POST zahteva za odvezivanje korisnika sa prostorom
            const response = await axios.post(
                `${API_URL}/svi_korisnici/odvezi_detalje_korisnika`,
                requestBody,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            if (response.status === 200) {
                setSuccessMessage("Korisnik je uspešno odvezan od prostora.");
                // Resetovanje selektovanog korisnika
                setSelectedSifra("");
                // Osvežavanje stranice nakon uspeha
                window.location.reload();
            }
        } catch (error) {
            setErrorMessage("Došlo je do greške prilikom uklanjanja prostora. Pokušajte ponovo.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleOpenPoveziDetaljeKorisnikaDialog = () => {
        setErrorMessage("");
        setSuccessMessage("");
        setNewSifraKorisnika("");
        setOpenPoveziDetaljeKorisnikaDialog(!openPoveziDetaljeKorisnikaDialog);
    };

    const handleOpenOdveziDetaljeKorisnikaDialog = () => {
        setErrorMessage("");
        setSuccessMessage("");
        setNewSifraKorisnika("");
        setOpenOdveziDetaljeKorisnikaDialog(!openOdveziDetaljeKorisnikaDialog);
    };

    // send email - user function
    const handleSubmitSendEmail = async (e) => {
        e.preventDefault();

        // Provera svih obaveznih polja
        if (!issueType || !message || !attachment || !phoneNumber) {
            setOpenContactFormErrorDialog(true); // Otvori dijalog
            return;
        }

        const isTokenValid = checkToken();
        if (!isTokenValid) {
            // Ako token nije validan, neće nastaviti dalje
            return;
        }

        // Provera tipa fajla
        const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];
        if (!allowedTypes.includes(attachment.type)) {
            setErrorMessage("Dozvoljeni formati su samo slike (PNG, JPG, JPEG) i PDF.");
            setOpenErrorDialog(true);
            return;
        }

        setIsLoading(true);

        try {
            const formData = new FormData();

            // Priprema JSON podataka za emailKontakt
            const emailKontakt = {
                poruka: message,
                datumSlanja: new Date().toLocaleString("sv-SE", { timeZone: "Europe/Belgrade" }).replace(" ", "T") + ".000Z",
                vrstaKontakta: issueType.toUpperCase(),
                registrovaniKorisnik: user,
                brojTelefona: phoneNumber
            };

            // Dodavanje podataka u FormData
            formData.append("emailKontakt", new Blob([JSON.stringify(emailKontakt)], { type: "application/json" }));
            formData.append("attachment", attachment);

            const API_URL = process.env.REACT_APP_API_URL;

            // Slanje zahteva sa FormData
            const response = await axios.post(
                `${API_URL}/emails/send`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${token}`
                    },
                }
            );

            if (response.status === 200) {
                setOpenEmailConfirmationDialog(true); // Otvori dijalog
                setTimeout(() => {
                    setOpenEmailConfirmationDialog(false); // Automatski zatvori dijalog nakon 4 sekunde
                }, 5500);

                setIssueType("");
                setMessage("");
                setAttachment(null); // Resetuj attachment
                setPhoneNumber(""); // Resetuj broj telefona
            }
        } catch (error) {
            setErrorMessage("Došlo je do greške prilikom slanja poruke. Proverite vašu internet konekciju i velicinu poslate slike, koja ne može da premasuje 10MB. Pokušajte ponovo kasnije.");
            setOpenErrorDialog(true);
        } finally {
            setIsLoading(false); // Kraj slanja - uklanjanje spinnera
        }
    };

    const handleOpenEmailConfirmationDialog = () => {
        setOpenEmailConfirmationDialog(!openEmailConfirmationDialog);
    };

    const handleOpenContactFormErrorDialog = () => {
        setOpenContactFormErrorDialog(!openContactFormErrorDialog);
    };

    // status neispravan - spam dialoga
    const handleOpenStatusNeispravanDialog = () => {
        setOpenStatusNeispravanDialog(!openStatusNeispravanDialog);
    };

    useEffect(() => {
        if (user && defaultDetaljiKorisnika?.statusKalorimetra === false) {
            setOpenStatusNeispravanDialog(true); // Otvori dijalog ako je status false
        }
    }, [user, defaultDetaljiKorisnika]);

    // update database as admin
    const handleUploadDatabase = async () => {
        const isTokenValid = checkToken();
        if (!isTokenValid) {
            // Ako token nije validan, neće nastaviti dalje
            return;
        }

        if (!attachmentCsv) {
            setOpenAttachmentCsvChooseDialog(true); // Otvori dijalog
            return;
        }

        const formData = new FormData();
        formData.append("file", attachmentCsv); // Ključ mora da se poklapa sa parametrom na backendu

        const API_URL = process.env.REACT_APP_API_URL;

        setIsUploadingDatabase(true);

        try {
            await axios.post(
                `${API_URL}/svi_korisnici/upload`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${token}`
                    },
                }
            );
            setOpenAttachmentCsvSentDialog(true); // Otvori dijalog
            setTimeout(() => {
                setOpenAttachmentCsvSentDialog(false); // Automatski zatvori dijalog nakon 4 sekunde
            }, 5500);
        } catch (error) {
            setErrorMessage("Došlo je do greške. Molimo pokušajte kasnije ili kontaktirajte developera.");
            setOpenErrorDialog(true);
        } finally {
            setIsUploadingDatabase(false);
        }
    };

    const handleOpenAttachmentCsvSentDialog = () => {
        setOpenAttachmentCsvSentDialog(!openAttachmentCsvSentDialog);
    };

    const handleOpenAttachmentCsvChooseDialog = () => {
        setOpenAttachmentCsvChooseDialog(!openAttachmentCsvChooseDialog);
    };

    // update consumption history - admin function
    const handleSubmitPopulateWithData = async () => {
        if (!token) {
            return;
        }

        const API_URL = process.env.REACT_APP_API_URL;

        setIsLoadingPopulateWithData(true);

        try {
            const response = await axios.post(
                `${API_URL}/consumption_history/populate`,
                {},
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    },
                }
            );

            if (response.status === 200) {
                setOpenPopulateConsumptionHistoryDialog(true);
                setTimeout(() => {
                    setOpenPopulateConsumptionHistoryDialog(false);
                }, 4000);
            }
        } catch (error) {
            setErrorMessage("Došlo je do greške. Molimo pokušajte kasnije ili kontaktirajte developera.");
            setOpenErrorDialog(true);
        } finally {
            setIsLoadingPopulateWithData(false);
        }
    };

    const handleSubmitPopulateWithZero = async () => {
        if (!token) {
            return;
        }

        const API_URL = process.env.REACT_APP_API_URL;

        setIsLoadingPopulateWithZero(true);

        try {
            const response = await axios.post(
                `${API_URL}/consumption_history/populate_zero`,
                {},
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    },
                }
            );

            if (response.status === 200) {
                setOpenPopulateConsumptionHistoryWithZeroDialog(true);
                setTimeout(() => {
                    setOpenPopulateConsumptionHistoryWithZeroDialog(false);
                }, 4000);
            }
        } catch (error) {
            setErrorMessage("Došlo je do greške. Molimo pokušajte kasnije ili kontaktirajte developera.");
            setOpenErrorDialog(true);
        } finally {
            setIsLoadingPopulateWithZero(false);
        }
    };

    const handleOpenPopulateConsumptionHistoryDialog = () => {
        setOpenPopulateConsumptionHistoryDialog(!openPopulateConsumptionHistoryDialog);
    };

    const handleOpenPopulateConsumptionHistoryWithZeroDialog = () => {
        setOpenPopulateConsumptionHistoryWithZeroDialog(!openPopulateConsumptionHistoryWithZeroDialog);
    };

    // promena sifre korisnika
    const handleChangeSifra = (e) => {
        setSelectedSifra(e.target.value);
        setIsSifraChanged(true);
    };

    useEffect(() => {
        if (!isSifraChanged) return;  // Ne prikazuj dijalog ako selekcija nije promenjena

        const selectedUser = detaljiKorisnika.find(
            (korisnik) => korisnik.sifraKorisnika === selectedSifra
        );

        if (selectedUser && !selectedUser.statusKalorimetra) {
            // Ako je status kalorimetra neispravan, otvori dijalog odmah
            setOpenStatusNeispravanDialog(true);
        }
    }, [selectedSifra, detaljiKorisnika, isSifraChanged]);

    useEffect(() => {
        if (user && detaljiKorisnika) {
            const selected = detaljiKorisnika.find(korisnik => korisnik.sifraKorisnika === user.sifraKorisnika);
            if (selected) {
                setSelectedSifra(selected.sifraKorisnika);
            }
        }
    }, [user, detaljiKorisnika]);

    // sort and search function in table - admin
    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const parseTitle = (title) => {
        return title
            .toLowerCase()
            .split(/(\d+)/)
            .map(part => isNaN(part) ? part : parseInt(part, 10));
    };


    const filteredRegistrovaniKorisnici = registrovaniKorisnici.filter(registrovaniKorisnik =>
        registrovaniKorisnik.sifraKorisnika.includes(searchQuery)
    );

    const sortedRegistrovaniKorisnici = sortConfig
        ? [...filteredRegistrovaniKorisnici]
            .sort((a, b) => {
                const aValue = a[sortConfig.key];
                const bValue = b[sortConfig.key];

                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    const parsedA = parseTitle(aValue);
                    const parsedB = parseTitle(bValue);
                    for (let i = 0; i < Math.max(parsedA.length, parsedB.length); i++) {
                        if (parsedA[i] < parsedB[i]) return sortConfig.direction === 'ascending' ? -1 : 1;
                        if (parsedA[i] > parsedB[i]) return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                }

                if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
                if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
                return 0;
            })
        : filteredRegistrovaniKorisnici;


    const handleSortSviKorisnici = (key) => {
        let direction = 'ascending';
        if (sortConfigSviKorisnici && sortConfigSviKorisnici.key === key && sortConfigSviKorisnici.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfigSviKorisnici({ key, direction });
    };

    const filteredSviKorisnici = sviKorisnici.filter(korisnik =>
        korisnik.sifraKorisnika.includes(searchQuerySviKorisnici)
    );

    const sortedSviKorisnici = sortConfigSviKorisnici
        ? [...filteredSviKorisnici]
            .sort((a, b) => {
                const aValue = a[sortConfigSviKorisnici.key];
                const bValue = b[sortConfigSviKorisnici.key];

                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    const parsedA = parseTitle(aValue);
                    const parsedB = parseTitle(bValue);
                    for (let i = 0; i < Math.max(parsedA.length, parsedB.length); i++) {
                        if (parsedA[i] < parsedB[i]) return sortConfigSviKorisnici.direction === 'ascending' ? -1 : 1;
                        if (parsedA[i] > parsedB[i]) return sortConfigSviKorisnici.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                }

                if (aValue < bValue) return sortConfigSviKorisnici.direction === 'ascending' ? -1 : 1;
                if (aValue > bValue) return sortConfigSviKorisnici.direction === 'ascending' ? 1 : -1;
                return 0;
            })
        : filteredSviKorisnici;


    // delete user - admin
    const handleDelete = async (id) => {

        const API_URL = process.env.REACT_APP_API_URL;

        try {
            await axios.delete(`${API_URL}/users/delete/${id}`, {
                headers: { "Authorization": `Bearer ${token}` }
            });

            // Ažuriraj listu korisnika nakon brisanja
            setRegistrovaniKorisnici(prevKorisnici => prevKorisnici.filter(korisnik => korisnik.id !== id));
        } catch (error) {
            console.error("Greška prilikom brisanja korisnika:", error);
        }
    };

    const handleOpenDeleteRegistrovaniKorisnikDialog = (id = null) => {
        setSelectedUserId(id);
        setOpenDeleteRegistrovaniKorisnikDialog(prev => !prev);
    };


    // verify user - admin
    const handleVerifyUser = async (id) => {
        const API_URL = process.env.REACT_APP_API_URL;

        try {
            await axios.post(`${API_URL}/users/verify/${id}`, {}, {
                headers: { "Authorization": `Bearer ${token}` }
            });

            setRegistrovaniKorisnici(prevKorisnici =>
                prevKorisnici.map(korisnik =>
                    korisnik.id === id ? { ...korisnik, verifikovan: true } : korisnik
                )
            );

            handleOpenVerifyRegistrovaniKorisnikDialog();
        } catch (error) {
            console.error("Greška prilikom verifikacije korisnika:", error);
        }
    };

    const handleOpenVerifyRegistrovaniKorisnikDialog = (id = null) => {
        setSelectedUserId(id);
        setOpenVerifyRegistrovaniKorisnikDialog(prev => !prev);
    };

    // print function - user
    const handlePrint = () => {
        const elements = document.querySelectorAll('.no-print');
        elements.forEach(el => el.style.display = 'none');

        window.print();

        setTimeout(() => {
            elements.forEach(el => el.style.display = '');
        }, 100);
    };


    const currentYear = new Date().getFullYear();

    useEffect(() => {
        const scrollPosition = sessionStorage.getItem('scrollPosition');
        if (scrollPosition) {
            window.scrollTo(0, parseInt(scrollPosition));
            sessionStorage.removeItem('scrollPosition');
        } else {
            window.scrollTo(0, 0);
        }
    }, []);


    return (
        <>
            {user?.role === "USER" && (
                <div className="">
                    <div className="justify-center w-[calc(100%)] min-h-screen bg-white">
                        <div className="h-5 bg-gray-50"></div>

                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                            {/* Levi krug */}
                            <div
                                className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob"
                                style={{ top: '40%', left: '30%', transform: 'translate(-80%, -50%)' }}
                            ></div>
                            {/* Desni krug */}
                            <div
                                className="absolute w-[35vw] h-[35vw] bg-red-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-2000"
                                style={{ top: '60%', left: '60%', transform: 'translate(-20%, -50%)' }}
                            ></div>
                            {/* Donji krug */}
                            <div
                                className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-4000"
                                style={{ top: '55%', left: '55%', transform: 'translate(-50%, 10%)' }}
                            ></div>
                        </div>

                        <div className="mx-2">
                            <Menu />
                            <div className="h-6 bg-grayblue-50"></div>
                            <div className="container mx-auto flex flex-col relative z-10">
                                {/* Naslovi preko cele širine */}
                                <div className="flex justify-between items-center mb-8">
                                    {/* Leva strana */}
                                    <div className="flex-1">
                                        <h1 className="text-4xl sm:text-5xl xl:text-6xl text-blue-800 font-bold leading-tight tracking-tight">
                                            Smart Service System
                                        </h1>
                                        <h2 className="text-2xl sm:text-3xl xl:text-4xl text-red-700 uppercase font-semibold leading-tight tracking-wider mt-4">
                                            Uvid u potrošnju
                                        </h2>
                                    </div>

                                    {/* Desna strana */}
                                    <div className="flex flex-col items-start w-[30%] space-y-4 ml-4 no-print">
                                        {/* Select meni */}
                                        {/* Select za desktop */}
                                        <select
                                            className="text-gray-900 border border-gray-300 rounded-md p-2 md:block hidden"
                                            value={selectedSifra}
                                            onChange={handleChangeSifra}
                                        >
                                            {detaljiKorisnika.map((korisnik) => (
                                                <option key={korisnik.sifraKorisnika} value={korisnik.sifraKorisnika}>
                                                    {`${korisnik.sifraKorisnika} - ${korisnik.adresa} - ${korisnik.brojStana}`}
                                                </option>
                                            ))}
                                        </select>

                                        {/* Select za mobilni prikaz */}
                                        <select
                                            className="text-gray-900 border border-gray-300 rounded-md p-2 md:hidden block"
                                            value={selectedSifra}
                                            onChange={handleChangeSifra}
                                        >
                                            {detaljiKorisnika.map((korisnik) => (
                                                <option key={korisnik.sifraKorisnika} value={korisnik.sifraKorisnika}>
                                                    {korisnik.sifraKorisnika}
                                                </option>
                                            ))}
                                        </select>

                                        {/* Dugme */}
                                        <div className="mb-4 mt-3">
                                            <label
                                                className="flex items-center cursor-pointer text-gray-500 hover:text-gray-700"
                                                onClick={handleOpenPoveziDetaljeKorisnikaDialog} // Pozivanje funkcije za otvaranje dijaloga
                                            >
                                                <PlusCircleIcon className="h-6 w-6 mr-2 text-blue-700" />
                                                <span className="text-sm text-gray-500 hover:text-gray-700">
                                                    Dodaj prostor
                                                </span>
                                            </label>
                                        </div>

                                        <div className="mb-4 mt-3">
                                            <label
                                                className="flex items-center cursor-pointer text-gray-500 hover:text-gray-700"
                                                onClick={handleOpenOdveziDetaljeKorisnikaDialog} // Pozivanje funkcije za otvaranje dijaloga
                                            >
                                                <MinusCircleIcon className="h-6 w-6 mr-2 text-red-700" />
                                                <span className="text-sm text-gray-500 hover:text-gray-700">
                                                    Ukloni prostor
                                                </span>
                                            </label>
                                        </div>

                                        <div className="mb-4 mt-3">
                                            <label
                                                className="flex items-center cursor-pointer text-gray-500 hover:text-gray-700"
                                                onClick={handlePrint}
                                            >
                                                <PrinterIcon className="h-6 w-6 mr-2 text-blue-700" />
                                                <span className="text-sm text-gray-500 hover:text-gray-700">
                                            Štampaj stranicu
                                        </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Glavni deo sa tabelom i tekstom */}
                                <div className="lg:flex lg:gap-8 items-start">
                                    {/* Leva strana - Tabela */}
                                    <div className="lg:w-1/2 lg:mb-12 mb-8">
                                        <table className="w-full max-w-full mx-auto bg-white rounded-lg shadow-xl overflow-hidden mb-8 table-auto">
                                            <tbody>
                                            <tr className="bg-gray-50 text-blue-gray-900">
                                                <th className="px-6 py-4 text-left text-sm font-medium">Status merila toplotne energije</th>
                                                <th className="px-6 py-4 text-left text-sm font-medium">
                                                    {detaljiKorisnika.map((korisnik) => {
                                                        if (korisnik.sifraKorisnika === selectedSifra) {
                                                            return korisnik.statusKalorimetra ? (
                                                                <span className="rounded-full cursor-pointer bg-green-100 text-green-800 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent px-3 py-1">
                                                                    Ispravno
                                                                </span>
                                                            ) : (
                                                                <span className="rounded-full cursor-pointer bg-red-100 text-red-800 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent px-3 py-1">
                                                                    Neispravno
                                                                </span>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </th>
                                            </tr>
                                            {detaljiKorisnika.map((korisnik) => {
                                                if (korisnik.sifraKorisnika === selectedSifra) {
                                                    return (
                                                        <>
                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Šifra korisnika</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.sifraKorisnika}</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Naziv vlasnika</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.imePrezime}</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Adresa</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900 w-2/5">{korisnik.adresa}</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Kućni broj</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.brojStana}</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Grejna površina</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.grejnaPovrsina} m²</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Datum očitavanja MTE</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">
                                                                    {korisnik.datumOcitavanjaMTE
                                                                        ? formatDate(korisnik.datumOcitavanjaMTE)
                                                                        : "N/A"}
                                                                </td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Staro stanje MTE</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.staroStanjeMTE} kWh</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Novo stanje MTE</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.novoStanjeMTE} kWh</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Očitano</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.ocitano} kWh</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Ukupna potrošnja cele zgrade</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.ukupnaPotrosnjaCeleZgrade} kWh</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Koeficijent učešća po MTE (KK)</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.koeficijentPoMTE}</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Koeficijent učešća u zajedničkoj potrošnji (KU)</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.koeficijentUcesca}</td>
                                                            </tr>

                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-700">Koeficijent raspodele (KR)</td>
                                                                <td className="px-6 py-4 text-sm text-gray-900">{korisnik.koeficijentRaspodele}</td>
                                                            </tr>

                                                            {/* Legend */}
                                                            <tr className="bg-gray-50">
                                                                <td colSpan="2" className="px-6 py-4 text-[13px] font-medium text-gray-700 text-center">
                                                                    <div className="text-lg font-bold mb-2">Legenda</div>
                                                                    <div className="grid grid-cols-2 gap-x-4 text-[13px] text-gray-800">
                                                                        <div className="flex flex-col">
                                                                            <p className="text-left"><strong>Koeficijent učešća po MTE:</strong> <span className="font-light text-gray-800">KK = PMTE / UP * 0.8</span></p>
                                                                            <p className="text-left"><strong>Koeficijent učešća u zajedničkoj potrošnji:</strong> <span className="font-light text-gray-800">KU = UPR / 0.2 ili KU = 0.2 * (GP/UGP)</span></p>
                                                                            <p className="text-left"><strong>MTE</strong> - <span className="font-light text-gray-800">Merilo toplotne energije</span></p>
                                                                            <p className="text-left"><strong>KR</strong> - <span className="font-light text-gray-800">Koeficijent raspodele: KR = KK + KU</span></p>
                                                                        </div>
                                                                        <div className="flex flex-col">
                                                                            <p className="text-left"><strong>PMTE</strong> - <span className="font-light text-gray-800">Potrošnja po merilu toplotne energije</span></p>
                                                                            <p className="text-left"><strong>UP</strong> - <span className="font-light text-gray-800">Ukupna potrošnja toplotne energije</span></p>
                                                                            <p className="text-left"><strong>UPR</strong> - <span className="font-light text-gray-800">Ukupno prostora u jednoj SZ</span></p>
                                                                            <p className="text-left"><strong>KU</strong> - <span className="font-light text-gray-800">Koeficijent učešća u zajedničkoj potrošnji</span></p>
                                                                            <p className="text-left"><strong>GP</strong> - <span className="font-light text-gray-800">Grejna površina</span></p>
                                                                            <p className="text-left"><strong>UGP</strong> - <span className="font-light text-gray-800">Ukupna grejna površina</span></p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            {/* Additional Messages */}
                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-semibold text-blue-900" colSpan="2">
                                                                    <span className="mr-2">&bull;</span> Ukoliko imate bilo kakve primedbe na očitane vrednosti, kontaktirajte nas putem kontakt forme
                                                                </td>
                                                            </tr>
                                                            {!korisnik.statusKalorimetra && (
                                                            <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                <td className="px-6 py-4 text-sm font-semibold text-red-900" colSpan="2">
                                                                    Detaljne informacije:
                                                                </td>
                                                            </tr>
                                                            )}
                                                            {!korisnik.statusKalorimetra && (
                                                                <tr className="hover:bg-gray-100 transition-colors duration-300">
                                                                    <td className="px-6 py-4 text-sm font-semibold text-red-900" colSpan="2">
                                                                        <span className="mr-2">&bull;</span> Vaše merilo toplotne energije je <b>neispravno</b>. Do uspostavljanja ispravnog rada uređaja, raspodela potrošnje toplotne energije za Vaš prostor vršiće se na osnovu procene. Molimo Vas da nas kontaktirate putem <b>kontakt forme</b> ili na mejl <b>info@smartservicesystem.rs</b>.
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    );
                                                }
                                                return null;
                                            })}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Desna strana - Lorem ipsum */}
                                    <div className="lg:w-1/2 mt-6 lg:mt-0 mb-12">

                                        <Card className="w-full shadow-lg mb-6">
                                            <CardBody>
                                                <div>
                                                    <Typography variant="h4" color="blue-gray" className="mb-2 flex items-center justify-between">
                                                        <span className="mb-2">Istorija potrošnje</span>
                                                        <BuildingOffice2Icon className="text-red-700 w-10 h-10 mb-4" />
                                                    </Typography>
                                                </div>

                                                <hr className="my-2 border-blue-gray-50 mb-4" />

                                                <div className="flow-root">
                                                    {Array.isArray(sortedDataGraph) && sortedDataGraph.length > 0 ? (
                                                        <ResponsiveContainer width="100%" height={300}>
                                                            <BarChart
                                                                width={500}
                                                                height={300}
                                                                data={sortedDataGraph}
                                                                margin={{
                                                                    top: 5,
                                                                    right: 30,
                                                                    left: 20,
                                                                    bottom: 5,
                                                                }}
                                                            >
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <XAxis
                                                                    dataKey="datum"
                                                                    tick={{ fontSize: 12, dy: 6 }}
                                                                    tickFormatter={(value) => formatToSerbianLatin(new Date(value))}
                                                                />
                                                                <YAxis tick={{ fontSize: 15, dx: -3 }} />
                                                                <Tooltip
                                                                    cursor={{ fill: '#E8F5E9' }}
                                                                    payloadArray={sortedDataGraph}
                                                                    content={<TooltipContent />}
                                                                    wrapperStyle={{ background: 'white', border: '2px solid #ddd', borderRadius: '8px', padding: '5px' }}
                                                                    offset={25}
                                                                />
                                                                <Legend />
                                                                <Bar dataKey="ocitano" name="Očitano (u kWh)" fill="#1565c0" />
                                                            </BarChart>
                                                        </ResponsiveContainer>
                                                    ) : (
                                                        <div>Nema podataka za prosli mesec</div>
                                                    )}
                                                </div>

                                            </CardBody>

                                        </Card>

                                        <h3 className="text-2xl font-bold text-gray-800 mb-4">Kontaktirajte nas</h3>

                                        {/* Forma */}
                                        <form className="space-y-6 no-print" onSubmit={handleSubmitSendEmail}>
                                            {/* Select za izbor vrste prijave */}
                                            <div className="mb-4">
                                                <label htmlFor="issueType" className="text-gray-700 font-medium">Izaberite tip prijave</label>
                                                <select
                                                    id="issueType"
                                                    name="issueType"
                                                    className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    value={issueType}
                                                    onChange={(e) => setIssueType(e.target.value)}
                                                >
                                                    <option value="" disabled>Izaberite...</option>
                                                    <option value="REKLAMACIJA">Uloži reklamaciju</option>
                                                    <option value="OSTALO">Ostalo</option>
                                                </select>
                                            </div>

                                            {/* Broj telefona */}
                                            <div className="mb-4">
                                                {/* Deo za broj telefona */}
                                                <div className="w-full">
                                                    <label htmlFor="phoneNumber" className="text-gray-700 font-medium">Broj telefona</label>
                                                    <input
                                                        id="phoneNumber"
                                                        name="phoneNumber"
                                                        type="tel"
                                                        className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        value={phoneNumber} // Ovaj input sada pokazuje samo broj telefona
                                                        onChange={(e) => setPhoneNumber(e.target.value)} // Samo unos broja telefona
                                                        placeholder="Unesite broj telefona..."
                                                    />
                                                </div>
                                            </div>

                                            {/* Textarea za unos poruke */}
                                            <div className="mb-2">
                                                <label htmlFor="message" className="text-gray-700 font-medium">Vaša poruka</label>
                                                <textarea
                                                    id="message"
                                                    name="message"
                                                    rows="5"
                                                    className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    placeholder="Unesite vašu poruku..."
                                                    value={message}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                    maxLength={4000}
                                                ></textarea>
                                                {/* Flex container za attachment i brojač karaktera */}
                                                <div className="flex items-center justify-between mt-1">
                                                    {/* Input za upload fajla */}
                                                    <label
                                                        htmlFor="attachment"
                                                        className="flex items-center cursor-pointer text-gray-500 hover:text-gray-700"
                                                    >
                                                        <PaperClipIcon className="h-6 w-6 mr-2 text-blue-700" /> {/* Ikonica u tamno plavoj boji */}
                                                        <span className="text-sm text-gray-500 hover:text-gray-700">
                                                            Priloži fotografiju
                                                        </span>
                                                    </label>
                                                    <input
                                                        id="attachment"
                                                        name="attachment"
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        className="hidden" // Sakriva standardni input
                                                        onChange={(e) => setAttachment(e.target.files[0])}
                                                    />
                                                    {/* Brojač karaktera */}
                                                    <div className={`text-sm ${message.length === 4000 ? "text-red-500" : "text-gray-500"}`}>
                                                        {message.length}/4000
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Preview odabrane slike */}
                                            {attachment && (
                                                <div className="mt-4 flex justify-center items-center space-x-4">
                                                    {attachment.type.startsWith("image/") ? (
                                                        // Preview za slike
                                                        <img
                                                            src={URL.createObjectURL(attachment)}
                                                            alt="Preview"
                                                            className="w-16 h-16 object-cover rounded border border-gray-300"
                                                        />
                                                    ) : attachment.type === "application/pdf" ? (
                                                        // Preview za PDF
                                                        <div className="flex items-center space-x-2">
                                                            <span className="text-gray-600">PDF dokument: {attachment.name}</span>
                                                            <a
                                                                href={URL.createObjectURL(attachment)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-blue-500"
                                                            >
                                                                Otvori
                                                            </a>
                                                        </div>
                                                    ) : (
                                                        <span className="text-red-500">Nepodržan format</span>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="text-gray-500 hover:text-gray-700"
                                                        onClick={() => setAttachment(null)}
                                                    >
                                                        <XMarkIcon className="h-6 w-6" />
                                                    </button>
                                                </div>
                                            )}

                                            {/* Dugme za slanje */}
                                            <div className="mb-4">
                                                <button
                                                    type="submit"
                                                    className="text-white font-semibold py-3 px-6 sm:py-4 sm:px-8 rounded-full shadow-lg bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-r hover:from-blue-600 hover:via-blue-700 hover:to-blue-800 transition-all duration-300 mt-4 flex items-center justify-center"
                                                    disabled={isLoading} // Onemogućava dugme dok traje slanje
                                                >
                                                    {isLoading ? (
                                                        <>
                                                            <Spinner className="h-5 w-5 mr-2" /> Molimo sačekajte...
                                                        </>
                                                    ) : (
                                                        "Pošaljite"
                                                    )}
                                                </button>
                                            </div>
                                        </form>

                                        <Dialog open={openEmailConfirmationDialog} handler={handleOpenEmailConfirmationDialog}>
                                            <DialogHeader>Poruka poslata</DialogHeader>
                                            <DialogBody>
                                                <p>Vaša poruka je poslata. Odgovorićemo vam u najkraćem mogućem roku.</p>
                                                <p className="mt-2">Hvala što ste nas kontaktirali.</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="blue"
                                                    onClick={handleOpenEmailConfirmationDialog}
                                                >
                                                    U redu
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>

                                        <Dialog open={openErrorDialog} handler={handleOpenErrorDialog}>
                                            <DialogHeader>Greška</DialogHeader>
                                            <DialogBody>
                                                <p>{errorMessage}</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="red"
                                                    onClick={handleOpenErrorDialog}
                                                >
                                                    U redu
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>

                                        <Dialog open={openContactFormErrorDialog} handler={handleOpenContactFormErrorDialog}>
                                            <DialogHeader>Greška prilikom slanja poruke</DialogHeader>
                                            <DialogBody>
                                                <p>Molimo vas popunite sva polja, ukljucujuci i prilog racuna u vidu slike i pokusajte opet.</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="blue"
                                                    onClick={handleOpenContactFormErrorDialog}
                                                >
                                                    U redu
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>

                                        <Dialog open={openStatusNeispravanDialog} handler={handleOpenStatusNeispravanDialog}>
                                            <DialogHeader>Vaše brojilo je neispravno</DialogHeader>
                                            <DialogBody>
                                                <p>Molimo Vas da kontaktirate Vašeg profesionalnog upravnika.</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="red"
                                                    onClick={handleOpenStatusNeispravanDialog}
                                                >
                                                    U redu
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>

                                        <Dialog open={openPoveziDetaljeKorisnikaDialog} handler={handleOpenPoveziDetaljeKorisnikaDialog}>
                                            <DialogHeader>Dodavanje novog prostora</DialogHeader>
                                            <DialogBody>
                                                <p>Molimo unesite šifru korisnika:</p>

                                                <input
                                                    type="text"
                                                    className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    value={newSifraKorisnika}
                                                    onChange={(e) => setNewSifraKorisnika(e.target.value)}
                                                />

                                                {/* Prikazivanje greške ako postoji */}
                                                {errorMessage && (
                                                    <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
                                                )}

                                                {/* Prikazivanje uspeha ako postoji */}
                                                {successMessage && (
                                                    <p className="text-green-500 text-sm mt-2">{successMessage}</p>
                                                )}
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="blue"
                                                    onClick={handlePoveziKorisnikaSubmit} // Pozivanje metode za submit
                                                >
                                                    Dodaj
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>
                                        <Dialog open={openOdveziDetaljeKorisnikaDialog} handler={handleOpenOdveziDetaljeKorisnikaDialog}>
                                            <DialogHeader>Uklonite prostor</DialogHeader>
                                            <DialogBody>
                                                <p>Molimo odaberite prostor koji želite da uklonite:</p>

                                                <select
                                                    className="text-gray-900 border border-gray-300 rounded-md p-2 mt-6 mb-2"
                                                    value={selectedSifra}
                                                    onChange={(e) => setSelectedSifra(e.target.value)}
                                                >
                                                    {detaljiKorisnika.map((korisnik) => (
                                                        <option key={korisnik.sifraKorisnika} value={korisnik.sifraKorisnika}>
                                                            {`${korisnik.sifraKorisnika} - ${korisnik.adresa} - ${korisnik.brojStana}`}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Prikazivanje greške ako postoji */}
                                                {errorMessage && (
                                                    <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
                                                )}

                                                {/* Prikazivanje uspeha ako postoji */}
                                                {successMessage && (
                                                    <p className="text-green-500 text-sm mt-2">{successMessage}</p>
                                                )}
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="red"
                                                    onClick={handleOdveziKorisnikaSubmit}
                                                >
                                                    Ukloni
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>
                                    </div>
                                </div>

                                {/*<div className="h-32 bg-gray-50"></div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {user?.role === "ADMIN" && (
                <div className="">
                    <div className="justify-center w-[calc(100%)] min-h-screen bg-white">
                        <div className="h-5 bg-gray-50"></div>

                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                            {/* Levi krug */}
                            <div
                                className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob"
                                style={{ top: '40%', left: '30%', transform: 'translate(-80%, -50%)' }}
                            ></div>
                            {/* Desni krug */}
                            <div
                                className="absolute w-[35vw] h-[35vw] bg-red-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-2000"
                                style={{ top: '60%', left: '60%', transform: 'translate(-20%, -50%)' }}
                            ></div>
                            {/* Donji krug */}
                            <div
                                className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-4000"
                                style={{ top: '55%', left: '55%', transform: 'translate(-50%, 10%)' }}
                            ></div>
                        </div>

                        <div className="mx-2">
                            <Menu />
                            <div className="h-6 bg-grayblue-50"></div>
                            <div className="container mx-auto flex flex-col relative z-10">
                                {/* Naslovi preko cele širine */}
                                <div className="flex justify-between items-center mb-8">
                                    {/* Leva strana */}
                                    <div className="flex-1">
                                        <h1 className="text-4xl sm:text-5xl xl:text-6xl text-blue-800 font-bold leading-tight tracking-tight">
                                            Smart Service System
                                        </h1>
                                        <h2 className="text-2xl sm:text-3xl xl:text-4xl text-red-700 uppercase font-semibold leading-tight tracking-wider mt-4">
                                            Administrator panel
                                        </h2>
                                    </div>

                                    {/* Desna strana */}
                                    <div className="flex flex-col items-start w-[30%] space-y-4 ml-4">
                                        {/* Dugme */}
                                        <div className="mb-4 mt-3">
                                            <label
                                                className={`flex items-center cursor-pointer text-gray-500 hover:text-gray-700 ${
                                                    isLoadingPopulateWithData ? "opacity-50 cursor-not-allowed" : ""
                                                }`}
                                                onClick={!isLoadingPopulateWithData ? handleSubmitPopulateWithData : undefined}
                                            >
                                                {isLoadingPopulateWithData ? (
                                                    <Spinner className="h-6 w-6 mr-2 text-blue-700" />
                                                ) : (
                                                    <ArchiveBoxArrowDownIcon className="h-6 w-6 mr-2 text-blue-700" />
                                                )}
                                                <span className="text-sm text-gray-500 hover:text-gray-700">
                                                    {isLoadingPopulateWithData ? "Ažuriranje u toku..." : "Ažuriraj istoriju potrošnje sa podacima"}
                                                </span>
                                            </label>
                                        </div>

                                        <div className="mb-4 mt-3">
                                            <label
                                                className={`flex items-center cursor-pointer text-gray-500 hover:text-gray-700 ${
                                                    isLoadingPopulateWithZero ? "opacity-50 cursor-not-allowed" : ""
                                                }`}
                                                onClick={!isLoadingPopulateWithZero ? handleSubmitPopulateWithZero : undefined}
                                            >
                                                {isLoadingPopulateWithZero ? (
                                                    <Spinner className="h-6 w-6 mr-2 text-red-700" />
                                                ) : (
                                                    <ArchiveBoxXMarkIcon className="h-6 w-6 mr-2 text-red-700" />
                                                )}
                                                <span className="text-sm text-gray-500 hover:text-gray-700">
                                                    {isLoadingPopulateWithZero ? "Ažuriranje u toku..." : "Ažuriraj istoriju potrošnje bez podataka"}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Glavni deo sa tabelom i tekstom */}
                                <div className="lg:flex lg:gap-8 items-start">
                                    {/* Leva strana - Tabela */}
                                    <div className="lg:w-1/2 lg:mb-24 mb-8">
                                        <div className="w-full">
                                            <div className="w-full flex items-center justify-start justify-center">
                                                <img
                                                    src="/images/logo/transparent%20logo.png"
                                                    alt="Smart Service System Logo"
                                                    className="h-[6.75rem] w-auto mt-20"
                                                />
                                            </div>
                                        </div>


                                    </div>

                                    {/* Desna strana - Lorem ipsum */}
                                    <div className="lg:w-1/2 mt-6 lg:mt-0 mb-12">

                                        <Card className="w-full shadow-lg mb-6">
                                            <CardBody>
                                                <div>
                                                    <Typography variant="h4" color="blue-gray" className="mb-2 flex items-center justify-between">
                                                        <span className="mb-2">Ažuriranje baze podataka</span>
                                                        <ArrowUpTrayIcon className="text-red-700 w-10 h-10 mb-4" />
                                                    </Typography>
                                                </div>

                                                <hr className="my-2 border-blue-gray-50 mb-4" />

                                                <div className="flex flex-col items-start space-y-4">
                                                    {/* Input za upload fajla */}
                                                    <div className="flex flex-col">
                                                        <label
                                                            htmlFor="attachmentCsv"
                                                            className="flex items-center cursor-pointer text-gray-500 hover:text-gray-700 mb-2"
                                                        >
                                                            <PaperClipIcon className="h-6 w-6 mr-2 text-blue-700" />
                                                            <span className="text-sm text-gray-500 hover:text-gray-700">
                                                                Kliknite da odaberete .csv fajl
                                                            </span>
                                                        </label>
                                                        <input
                                                            id="attachmentCsv"
                                                            name="attachmentCsv"
                                                            type="file"
                                                            accept=".csv"
                                                            className="hidden"
                                                            onChange={(e) => setAttachmentCsv(e.target.files[0])}
                                                        />
                                                        {/* Prikaz naziva odabranog fajla */}
                                                        {attachmentCsv && (
                                                            <div className="flex items-center space-x-2 mt-1">
                                                                {attachmentCsv.type === "text/csv" ? (
                                                                    // Preview za CSV
                                                                    <div className="flex items-center space-x-2">
                                                                        <span className="text-gray-600">
                                                                            CSV dokument:{" "}
                                                                            {attachmentCsv.name.length > 14
                                                                                ? `${attachmentCsv.name.substring(0, 14)}...`
                                                                                : attachmentCsv.name}
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                    <span className="text-red-500">Nepodržan format</span>
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    className="text-gray-500 hover:text-gray-700"
                                                                    onClick={() => {
                                                                        setAttachmentCsv(null); // Resetuj fajl
                                                                        document.getElementById("attachmentCsv").value = "";
                                                                    }}
                                                                >
                                                                    <XMarkIcon className="h-6 w-6" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Dugme za slanje */}
                                                    <div className="mb-4">
                                                        <button
                                                            type="button"
                                                            className="text-white font-semibold py-3 px-6 sm:py-4 sm:px-8 rounded-full shadow-lg bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-r hover:from-blue-600 hover:via-blue-700 hover:to-blue-800 transition-all duration-300 mt-4 flex items-center justify-center"
                                                            onClick={handleUploadDatabase}
                                                            disabled={isUploadingDatabase}
                                                        >
                                                            {isUploadingDatabase ? (
                                                                <>
                                                                    <Spinner className="h-5 w-5 mr-2" /> Ažuriranje...
                                                                </>
                                                            ) : (
                                                                "Ažuriraj"
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>

                                            </CardBody>

                                        </Card>

                                        <h3 className="text-2xl font-bold text-gray-800 mb-4"></h3>

                                        <Dialog open={openErrorDialog} handler={handleOpenErrorDialog}>
                                            <DialogHeader>Greška</DialogHeader>
                                            <DialogBody>
                                                <p>{errorMessage}</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="red"
                                                    onClick={handleOpenErrorDialog}
                                                >
                                                    U redu
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>

                                        <Dialog open={openAttachmentCsvSentDialog} handler={handleOpenAttachmentCsvSentDialog}>
                                            <DialogHeader>Ažuriranje</DialogHeader>
                                            <DialogBody>
                                                <p>Uspešno ste ažurirali vašu bazu podataka.</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="blue"
                                                    onClick={handleOpenAttachmentCsvSentDialog}
                                                >
                                                    U redu
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>

                                        <Dialog open={openPopulateConsumptionHistoryDialog} handler={handleOpenPopulateConsumptionHistoryDialog}>
                                            <DialogHeader>Ažuriranje</DialogHeader>
                                            <DialogBody>
                                                <p>Uspešno ste ažurirali istoriju potrošnje sa podacima.</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="blue"
                                                    onClick={handleOpenPopulateConsumptionHistoryDialog}
                                                >
                                                    U redu
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>

                                        <Dialog open={openPopulateConsumptionHistoryWithZeroDialog} handler={handleOpenPopulateConsumptionHistoryWithZeroDialog}>
                                            <DialogHeader>Ažuriranje</DialogHeader>
                                            <DialogBody>
                                                <p>Uspešno ste ažurirali istoriju potrošnje bez podataka.</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="blue"
                                                    onClick={handleOpenPopulateConsumptionHistoryWithZeroDialog}
                                                >
                                                    U redu
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>

                                        <Dialog open={openAttachmentCsvChooseDialog} handler={handleOpenAttachmentCsvChooseDialog}>
                                            <DialogHeader>Pažnja</DialogHeader>
                                            <DialogBody>
                                                <p>Molimo vas odaberite CSV fajl pomoću kog želite da ažurirate bazu podataka.</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="gradient"
                                                    color="blue"
                                                    onClick={handleOpenAttachmentCsvChooseDialog}
                                                >
                                                    U redu
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>
                                        <Dialog open={openDeleteRegistrovaniKorisnikDialog} handler={handleOpenDeleteRegistrovaniKorisnikDialog}>
                                            <DialogHeader>Pažnja</DialogHeader>
                                            <DialogBody>
                                                <p>Da li ste sigurni da želite da obrišete korisnika?</p>
                                                <br/>
                                                <p>Korisnik ce biti odvezan od svih prostora ukoliko potvrdite brisanje.</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="outlined"
                                                    color="gray"
                                                    onClick={handleOpenDeleteRegistrovaniKorisnikDialog}
                                                    className="mr-2"
                                                >
                                                    Ne
                                                </Button>
                                                <Button
                                                    variant="gradient"
                                                    color="red"
                                                    onClick={() => {
                                                        handleDelete(selectedUserId);
                                                        handleOpenDeleteRegistrovaniKorisnikDialog();
                                                    }}
                                                >
                                                    Da
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>
                                        <Dialog open={openVerifyRegistrovaniKorisnikDialog} handler={handleOpenVerifyRegistrovaniKorisnikDialog}>
                                            <DialogHeader>Verifikacija korisnika</DialogHeader>
                                            <DialogBody>
                                                <p>Da li ste sigurni da želite da verifikujete ovog korisnika?</p>
                                                <br/>
                                                <p>Nakon verifikacije, korisnik će moći da se prijavi.</p>
                                            </DialogBody>
                                            <DialogFooter>
                                                <Button
                                                    variant="outlined"
                                                    color="gray"
                                                    onClick={handleOpenVerifyRegistrovaniKorisnikDialog}
                                                    className="mr-2"
                                                >
                                                    Ne
                                                </Button>
                                                <Button
                                                    variant="gradient"
                                                    color="green"
                                                    onClick={() => handleVerifyUser(selectedUserId)}
                                                >
                                                    Da
                                                </Button>
                                            </DialogFooter>
                                        </Dialog>
                                    </div>
                                </div>

                                <Card className="w-full shadow-lg relative overflow-hidden">
                                    <CardBody className="relative">
                                        <Typography variant="h5" color="blue-gray" className="mb-4 flex items-center justify-between">
                                            Pregled Registrovanih Korisnika
                                            <div className="flex items-center ml-4">
                                                <span className="font-semibold mr-2">{registrovaniKorisnici.length}</span>
                                                <UserGroupIcon className="text-red-700 w-10 h-10" />
                                            </div>
                                        </Typography>
                                        <hr className="my-2 border-blue-gray-50" />

                                        <div className="relative overflow-x-auto h-[calc(100vh-24rem)]">
                                            <table className="min-w-full divide-y divide-gray-200">
                                                <thead className="sticky top-0 bg-gray-50 z-10">
                                                <tr>
                                                    <th onClick={() => handleSort('sifraKorisnika')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[130px]">
                                                        Sifra Korisnika
                                                        {sortConfig && sortConfig.key === 'sifraKorisnika' && (
                                                            sortConfig.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>
                                                    <th onClick={() => handleSort('email')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[135px]">
                                                        Email
                                                        {sortConfig && sortConfig.key === 'email' && (
                                                            sortConfig.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>
                                                    <th onClick={() => handleSort('datumKreiranja')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Datum Kreiranja
                                                        {sortConfig && sortConfig.key === 'datumKreiranja' && (
                                                            sortConfig.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSort('verifikacioniKod')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[135px]">
                                                        Verifikacioni Kod
                                                        {sortConfig && sortConfig.key === 'verifikacioniKod' && (
                                                            sortConfig.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSort('verifikovan')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[135px]">
                                                        Verifikovan
                                                        {sortConfig && sortConfig.key === 'verifikovan' && (
                                                            sortConfig.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSort('brojPovezanihProstora')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Broj Povezanih Prostora
                                                        {sortConfig && sortConfig.key === 'brojPovezanihProstora' && (
                                                            sortConfig.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSort('sifrePovezanihProstora')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Sifre Povezanih Prostora
                                                        {sortConfig && sortConfig.key === 'sifrePovezanihProstora' && (
                                                            sortConfig.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSort('akcije')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[135px]">
                                                        Akcije
                                                        {sortConfig && sortConfig.key === 'akcije' && (
                                                            sortConfig.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th className="px-6 py-3 border-b border-gray-200"></th>
                                                </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-300">
                                                {sortedRegistrovaniKorisnici.map((registrovaniKorisnik) => (
                                                    <tr key={registrovaniKorisnik.id}>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {registrovaniKorisnik.sifraKorisnika}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {registrovaniKorisnik.email}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                            {registrovaniKorisnik.datumKreiranja ?
                                                                new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(registrovaniKorisnik.datumKreiranja))
                                                                : '/'
                                                            }
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {registrovaniKorisnik.verifikacioniKod}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <div className={`text-center inline-flex px-2 text-xs font-semibold rounded-md cursor-pointer
                                                                    ${registrovaniKorisnik.verifikovan === true ? "bg-green-100 text-green-800" : ""}
                                                                    ${registrovaniKorisnik.verifikovan === false ? "bg-red-100 text-red-800" : ""}
                                                                    border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}>
                                                                {registrovaniKorisnik.verifikovan === true ? "Verifikovan" : ""}
                                                                {registrovaniKorisnik.verifikovan === false ? "Nije verifikovan" : ""}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {Number.isFinite(registrovaniKorisnik.brojPovezanihProstora)
                                                                    ? registrovaniKorisnik.brojPovezanihProstora
                                                                    : '0'}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {registrovaniKorisnik.sifrePovezanihProstora.join(', ')}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            {registrovaniKorisnik.role !== 'ADMIN' && (
                                                                <>
                                                                    <button
                                                                        onClick={() => handleOpenDeleteRegistrovaniKorisnikDialog(registrovaniKorisnik.id)}
                                                                        className="text-red-600 hover:text-red-800 mr-4"
                                                                        title="Obrišite ovog korisnika"
                                                                    >
                                                                        <TrashIcon className="w-5 h-5" />
                                                                    </button>
                                                                    {!registrovaniKorisnik.verifikovan && (
                                                                        <button
                                                                            onClick={() => handleOpenVerifyRegistrovaniKorisnikDialog(registrovaniKorisnik.id)}
                                                                            className="text-green-600 hover:text-green-800"
                                                                            title="Verifikujte ovog korisnika"
                                                                        >
                                                                            <CheckCircleIcon className="w-5 h-5" />
                                                                        </button>
                                                                    )}
                                                                </>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="flex items-center mt-5 w-full gap-2 md:w-max">
                                            <div className="relative">
                                                <Input
                                                    type="search"
                                                    placeholder="Search"
                                                    containerProps={{
                                                        className: "min-w-full sm:min-w-[288px]",
                                                    }}
                                                    className="!border-t-blue-gray-300 pl-9 placeholder:text-blue-gray-300 focus:!border-blue-gray-300"
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                />
                                                <div className="!absolute left-3 top-[13px]">
                                                    <svg
                                                        width="13"
                                                        height="14"
                                                        viewBox="0 0 14 15"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M9.97811 7.95252C10.2126 7.38634 10.3333 6.7795 10.3333 6.16667C10.3333 4.92899 9.84167 3.742 8.9665 2.86683C8.09133 1.99167 6.90434 1.5 5.66667 1.5C4.42899 1.5 3.242 1.99167 2.36683 2.86683C1.49167 3.742 1 4.92899 1 6.16667C1 6.7795 1.12071 7.38634 1.35523 7.95252C1.58975 8.51871 1.93349 9.03316 2.36683 9.4665C2.80018 9.89984 3.31462 10.2436 3.88081 10.4781C4.447 10.7126 5.05383 10.8333 5.66667 10.8333C6.2795 10.8333 6.88634 10.7126 7.45252 10.4781C8.01871 10.2436 8.53316 9.89984 8.9665 9.4665C9.39984 9.03316 9.74358 8.51871 9.97811 7.95252Z"
                                                            fill="#CFD8DC"
                                                        />
                                                        <path
                                                            d="M13 13.5L9 9.5M10.3333 6.16667C10.3333 6.7795 10.2126 7.38634 9.97811 7.95252C9.74358 8.51871 9.39984 9.03316 8.9665 9.4665C8.53316 9.89984 8.01871 10.2436 7.45252 10.4781C6.88634 10.7126 6.2795 10.8333 5.66667 10.8333C5.05383 10.8333 4.447 10.7126 3.88081 10.4781C3.31462 10.2436 2.80018 9.89984 2.36683 9.4665C1.93349 9.03316 1.58975 8.51871 1.35523 7.95252C1.12071 7.38634 1 6.7795 1 6.16667C1 4.92899 1.49167 3.742 2.36683 2.86683C3.242 1.99167 4.42899 1.5 5.66667 1.5C6.90434 1.5 8.09133 1.99167 8.9665 2.86683C9.84167 3.742 10.3333 4.92899 10.3333 6.16667Z"
                                                            stroke="#CFD8DC"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                            <Button size="md" className="rounded-lg bg-blue-700">
                                                Search
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>

                                <Card className="w-full shadow-lg relative overflow-hidden mt-8">
                                    <CardBody className="relative">
                                        <Typography variant="h5" color="blue-gray" className="mb-4 flex items-center justify-between">
                                            Pregled Svih Prostora
                                            <div className="flex items-center ml-4">
                                                <span className="font-semibold mr-2">{sviKorisnici.length}</span>
                                                <BuildingOffice2Icon className="text-red-700 w-10 h-10" />
                                            </div>
                                        </Typography>
                                        <hr className="my-2 border-blue-gray-50" />

                                        <div className="relative overflow-x-auto h-[calc(100vh-24rem)]">
                                            <table className="min-w-full divide-y divide-gray-200">
                                                <thead className="sticky top-0 bg-gray-50 z-10">
                                                <tr>
                                                    <th onClick={() => handleSortSviKorisnici('sifraKorisnika')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[130px]">
                                                        Sifra Korisnika
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'sifraKorisnika' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>
                                                    <th onClick={() => handleSortSviKorisnici('imePrezime')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[135px]">
                                                        Ime i Prezime
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'imePrezime' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>
                                                    <th onClick={() => handleSortSviKorisnici('adresa')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Adresa i Broj Stana
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'adresa' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('grejnaPovrsina')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Grejna Povrsina
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'grejnaPovrsina' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('datumOcitavanjaMTE')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Datum Ocitavanja MTE
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'datumOcitavanjaMTE' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('staroStanjeMTE')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Staro Stanje MTE
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'staroStanjeMTE' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('novoStanjeMTE')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Novo Stanje MTE
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'novoStanjeMTE' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('ocitano')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Ocitano
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'ocitano' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('ukupnaPotrosnjaCeleZgrade')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Ukupna Potrosnja Cele Zgrade
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'ukupnaPotrosnjaCeleZgrade' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('koeficijentPoMTE')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Koeficijent po MTE
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'koeficijentPoMTE' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('koeficijentUcesca')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Koeficijent Ucesca
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'koeficijentUcesca' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('koeficijentRaspodele')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Koeficijent Raspodele
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'koeficijentRaspodele' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('statusKalorimetra')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Status Kalorimetra
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'statusKalorimetra' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th onClick={() => handleSortSviKorisnici('registrovaniKorisnik.sifraKorisnika')} className="px-6 py-3 text-xs font-medium text-gray-500 hover:text-cyan-900 uppercase tracking-wider text-left border-b border-gray-200 cursor-pointer min-w-[185px]">
                                                        Sifra Registrovanog Korisnika
                                                        {sortConfigSviKorisnici && sortConfigSviKorisnici.key === 'registrovaniKorisnik.sifraKorisnika' && (
                                                            sortConfigSviKorisnici.direction === 'ascending'
                                                                ? <ArrowLongUpIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                                : <ArrowLongDownIcon strokeWidth={2} className="w-4 h-4 inline ml-2 text-cyan-800" />
                                                        )}
                                                    </th>

                                                    <th className="px-6 py-3 border-b border-gray-200"></th>
                                                </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-300">
                                                {sortedSviKorisnici.map((korisnik) => (
                                                    <tr key={korisnik.id}>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {korisnik.sifraKorisnika}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {korisnik.imePrezime}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                            <p className="text-sm text-gray-900">
                                                                {korisnik.adresa} {korisnik.brojStana}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {Number.isFinite(korisnik.grejnaPovrsina)
                                                                    ? korisnik.grejnaPovrsina + " m²"
                                                                    : '/'}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                            {korisnik.datumOcitavanjaMTE ?
                                                                new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(korisnik.datumOcitavanjaMTE))
                                                                : '/'
                                                            }
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {Number.isFinite(korisnik.staroStanjeMTE)
                                                                    ? korisnik.staroStanjeMTE + " kWh"
                                                                    : '/'}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {Number.isFinite(korisnik.novoStanjeMTE)
                                                                    ? korisnik.novoStanjeMTE + " kWh"
                                                                    : '/'}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {Number.isFinite(korisnik.ocitano)
                                                                    ? korisnik.ocitano + " kWh"
                                                                    : '/'}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {Number.isFinite(korisnik.ukupnaPotrosnjaCeleZgrade)
                                                                    ? korisnik.ukupnaPotrosnjaCeleZgrade + " kWh"
                                                                    : '/'}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {Number.isFinite(korisnik.koeficijentPoMTE)
                                                                    ? korisnik.koeficijentPoMTE
                                                                    : '/'}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {Number.isFinite(korisnik.koeficijentUcesca)
                                                                    ? korisnik.koeficijentUcesca
                                                                    : '/'}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {Number.isFinite(korisnik.koeficijentRaspodele)
                                                                    ? korisnik.koeficijentRaspodele
                                                                    : '/'}
                                                            </p>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <div className={`text-center inline-flex px-2 text-xs font-semibold rounded-md cursor-pointer
                                                                    ${korisnik.statusKalorimetra === true ? "bg-green-100 text-green-800" : ""}
                                                                    ${korisnik.statusKalorimetra === false ? "bg-red-100 text-red-800" : ""}
                                                                    border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}>
                                                                {korisnik.statusKalorimetra === true ? "Ispravan" : ""}
                                                                {korisnik.statusKalorimetra === false ? "Neispravan" : ""}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <p className="text-sm text-gray-900">
                                                                {korisnik.registrovaniKorisnik?.sifraKorisnika}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="flex items-center mt-5 w-full gap-2 md:w-max">
                                            <div className="relative">
                                                <Input
                                                    type="search"
                                                    placeholder="Search"
                                                    containerProps={{
                                                        className: "min-w-full sm:min-w-[288px]",
                                                    }}
                                                    className="!border-t-blue-gray-300 pl-9 placeholder:text-blue-gray-300 focus:!border-blue-gray-300"
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                    onChange={(e) => setSearchQuerySviKorisnici(e.target.value)}
                                                />
                                                <div className="!absolute left-3 top-[13px]">
                                                    <svg
                                                        width="13"
                                                        height="14"
                                                        viewBox="0 0 14 15"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M9.97811 7.95252C10.2126 7.38634 10.3333 6.7795 10.3333 6.16667C10.3333 4.92899 9.84167 3.742 8.9665 2.86683C8.09133 1.99167 6.90434 1.5 5.66667 1.5C4.42899 1.5 3.242 1.99167 2.36683 2.86683C1.49167 3.742 1 4.92899 1 6.16667C1 6.7795 1.12071 7.38634 1.35523 7.95252C1.58975 8.51871 1.93349 9.03316 2.36683 9.4665C2.80018 9.89984 3.31462 10.2436 3.88081 10.4781C4.447 10.7126 5.05383 10.8333 5.66667 10.8333C6.2795 10.8333 6.88634 10.7126 7.45252 10.4781C8.01871 10.2436 8.53316 9.89984 8.9665 9.4665C9.39984 9.03316 9.74358 8.51871 9.97811 7.95252Z"
                                                            fill="#CFD8DC"
                                                        />
                                                        <path
                                                            d="M13 13.5L9 9.5M10.3333 6.16667C10.3333 6.7795 10.2126 7.38634 9.97811 7.95252C9.74358 8.51871 9.39984 9.03316 8.9665 9.4665C8.53316 9.89984 8.01871 10.2436 7.45252 10.4781C6.88634 10.7126 6.2795 10.8333 5.66667 10.8333C5.05383 10.8333 4.447 10.7126 3.88081 10.4781C3.31462 10.2436 2.80018 9.89984 2.36683 9.4665C1.93349 9.03316 1.58975 8.51871 1.35523 7.95252C1.12071 7.38634 1 6.7795 1 6.16667C1 4.92899 1.49167 3.742 2.36683 2.86683C3.242 1.99167 4.42899 1.5 5.66667 1.5C6.90434 1.5 8.09133 1.99167 8.9665 2.86683C9.84167 3.742 10.3333 4.92899 10.3333 6.16667Z"
                                                            stroke="#CFD8DC"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                            <Button size="md" className="rounded-lg bg-blue-700">
                                                Search
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>



                                {/*<div className="h-32 bg-gray-50"></div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="flex gap-4 mt-24 mb-4">
                <footer className="relative w-full">
                    <div className="mx-auto w-full max-w-7xl px-8">
                        <div className="mx-auto grid w-full grid-cols-1 gap-8 py-12 md:grid-cols-2 lg:grid-cols-4">

                            <div className="w-full flex items-center justify-start lg:justify-center">
                                <img
                                    src="/transparent logo.png"
                                    alt="Smart Service System Logo"
                                    className="h-24 w-auto"
                                />
                            </div>

                            <div className="w-full no-print">
                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                    Navigacija
                                </Typography>
                                <ul className="space-y-1">
                                    <Link to="/">
                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                            <span className="inline-block py-1 pr-2">Početna strana</span>
                                        </Typography>
                                    </Link>
                                    <Link to="/o_nama">
                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                            <span className="inline-block py-1 pr-2">O nama</span>
                                        </Typography>
                                    </Link>
                                    <Link to="/saveti">
                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                            <span className="inline-block py-1 pr-2">Saveti</span>
                                        </Typography>
                                    </Link>
                                    <Link to="/kontakt">
                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                            <span className="inline-block py-1 pr-2">Kontakt</span>
                                        </Typography>
                                    </Link>
                                </ul>
                            </div>

                            <div className="w-full">
                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                    Kontakt
                                </Typography>
                                <ul className="space-y-1">
                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                        <span className="inline-block py-1 pr-2">Za sva Vaša pitanja</span>
                                    </Typography>
                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                        <span className="inline-block py-1 pr-2">stojimo na raspolaganju</span>
                                    </Typography>
                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                        <span className="inline-block py-1 pr-2">svakog radnog dana</span>
                                    </Typography>
                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                        <span className="inline-block py-1 pr-2">od 12-14h</span>
                                    </Typography>
                                </ul>
                            </div>

                            <div className="w-full">
                                <div className="flex items-center space-x-4 mb-4">
                                    <GlobeAltIcon className="h-5 w-5 text-gray-900" />
                                    <EnvelopeIcon className="h-5 w-5 text-gray-900" />
                                    <PhoneIcon className="h-5 w-5 text-gray-900" />
                                </div>
                                <ul className="space-y-1">
                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                        <span className="inline-block py-1 pr-2">www.smartservicesystem.rs</span>
                                    </Typography>
                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                        <span className="inline-block py-1 pr-2">info@smartservicesystem.rs</span>
                                    </Typography>
                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                        <span className="inline-block py-1 pr-2">+381 61 528 00 18</span>
                                    </Typography>
                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600 no-print">
                                        <a  href="/Politika%20privatnosti.pdf" target="_blank" rel="noopener noreferrer" className="inline-block py-1 pr-2">Politika privatnosti</a>
                                    </Typography>
                                </ul>
                            </div>
                        </div>
                        <div className="flex w-full flex-col items-center justify-center border-t border-blue-gray-50 py-4 md:flex-row md:justify-between">
                            <Typography
                                variant="small"
                                className="mb-4 text-center font-normal text-blue-gray-900 md:mb-0"
                            >
                                &copy; {currentYear} <a href="https://https://smartservicesystem.rs//">Smart Service System</a>. Sva
                                prava zadržana.
                            </Typography>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

export default HomePage;